import { render, staticRenderFns } from "./AssessmentAnalytics.vue?vue&type=template&id=6879a79c&"
import script from "./AssessmentAnalytics.vue?vue&type=script&lang=js&"
export * from "./AssessmentAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports